import '@hotwired/turbo-rails'
import * as ActiveStorage from '@rails/activestorage'
import '../initializers'

// Load Stimulus controllers
import '../controllers'

import '../lib/turbo-persist-scroll'

ActiveStorage.start()
